var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { CloseOutlined, SuccessFilled, LoadingOutlined, ErrorFilled, } from '@feb-team/legao-icons-react';
import { DivTag, LiTag, SpanTag } from '../../Utils/AtomicTag';
import { previewImage } from './utils';
var UploadList = /** @class */ (function (_super) {
    __extends(UploadList, _super);
    function UploadList(props) {
        return _super.call(this, props) || this;
    }
    UploadList.prototype.componentDidUpdate = function () {
        var _this = this;
        var _a = this.props, fileList = _a.fileList, previewFile = _a.previewFile;
        (fileList || []).forEach(function (file) {
            var isValidateFile = file.raw instanceof File || file.raw instanceof Blob;
            if (typeof document === 'undefined' ||
                typeof window === 'undefined' ||
                !window.FileReader ||
                !window.File ||
                !isValidateFile ||
                file.thumbUrl !== undefined) {
                return;
            }
            file.thumbUrl = '';
            if (previewFile) {
                previewFile(file.raw).then(function (previewDataUrl) {
                    file.thumbUrl = previewDataUrl || '';
                    _this.forceUpdate();
                });
            }
        });
    };
    UploadList.prototype.render = function () {
        var _a = this.props, fileList = _a.fileList, onRemove = _a.onRemove, listType = _a.listType;
        var listItem = [
            'relative',
            'text-sm',
            'hover:bg-brand-10',
            'cursor-pointer',
            'mb-px-5',
            'px-px-8',
        ];
        var listItemPictureCard = [
            'relative',
            'w-px-108',
            'h-px-108',
            'rounded-md',
            'cursor-pointer',
            'mr-px-10',
            'float-left',
            'overflow-hidden',
            'rounded-md',
        ];
        var operateBtns = [
            'absolute',
            'left-0',
            'top-0',
            'w-full',
            'h-full',
            'z-10',
            'text-sm',
            'flex',
            'justify-around',
            'items-center',
            'hidden',
            'opacity-0',
            'hover:bg-black',
            'hover:opacity-40',
            'rounded-md',
            'text-white',
        ];
        var statusSvg = [
            'absolute',
            'top-half',
            'leading-none',
            'h-px-14',
            '-mt-px-7',
        ];
        var successStatusSvg = __spread(statusSvg, ['text-succ-900']);
        var errorStatusSvg = __spread(statusSvg, ['text-error-900']);
        var removeSvg = [
            'absolute',
            'align-middle',
            'text-gray-500',
            'hidden',
            'text-xs',
            'top-half',
            '-mt-px-6',
            'mr-px-10',
            'right-0',
            'leading-none',
        ];
        var itemStatusMap = {
            success: 'text-brand-600',
            error: 'text-error-900',
        };
        var itemName = [
            'w-4/5',
            'inline-block',
            'truncate',
            'align-middle',
            'pl-px-20',
        ];
        return (React.createElement("ul", { className: "" + (listType === 'picture-card' ? 'float-left' : 'mt-px-15') }, fileList.map(function (item) {
            return listType === 'picture-card' ? (React.createElement(LiTag, { atomics: listItemPictureCard, className: "list-item", key: item.uid },
                React.createElement("img", { src: item.thumbUrl, alt: item.name }),
                React.createElement(DivTag, { atomics: operateBtns, className: "operate-btns" },
                    React.createElement(CloseOutlined, { onClick: function () {
                            onRemove(item);
                        } })))) : (React.createElement(LiTag, { atomics: listItem, className: "list-item", key: item.uid },
                item.status === 'success' && (React.createElement(SpanTag, { atomics: successStatusSvg },
                    React.createElement(SuccessFilled, null))),
                (item.status === 'uploading' || item.status === 'ready') && (React.createElement(SpanTag, { atomics: statusSvg },
                    React.createElement(LoadingOutlined, null))),
                item.status === 'error' && (React.createElement(SpanTag, { atomics: errorStatusSvg },
                    React.createElement(ErrorFilled, null))),
                item.status && (React.createElement(SpanTag, { atomics: itemName, className: "" + itemStatusMap[item.status], title: item.name }, item.name)),
                React.createElement(SpanTag, { atomics: removeSvg, className: "remove-svg" },
                    React.createElement(CloseOutlined, { onClick: function () {
                            onRemove(item);
                        } }))));
        })));
    };
    UploadList.defaultProps = {
        previewFile: previewImage,
    };
    return UploadList;
}(PureComponent));
export { UploadList };
